/**
 * Footer logo carousel — clones sets to fill the viewport and
 * drives a seamless infinite scroll via a CSS custom property.
 */
(function () {
    'use strict';

    var PIXELS_PER_SECOND = 50;

    function initLogoCarousels() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            return;
        }

        var carousels = document.querySelectorAll('.footer-logo-carousel');
        for (var i = 0; i < carousels.length; i++) {
            setupCarousel(carousels[i]);
        }
    }

    function setupCarousel(carousel) {
        var track = carousel.querySelector('.footer-logo-carousel__track');
        if (!track) return;

        var sets = track.querySelectorAll('.footer-logo-carousel__set');
        if (sets.length < 2) return;

        var firstSet = sets[0];
        var setWidth = firstSet.offsetWidth;
        if (setWidth <= 0) return;

        var viewportWidth = carousel.offsetWidth;

        // If one set is narrower than the viewport, clone items inside
        // both sets until a single set fills the viewport.
        if (setWidth < viewportWidth) {
            var originalItems = firstSet.innerHTML;
            var copies = Math.ceil(viewportWidth / setWidth);
            for (var c = 0; c < copies; c++) {
                firstSet.insertAdjacentHTML('beforeend', originalItems);
                sets[1].insertAdjacentHTML('beforeend', originalItems);
            }
            setWidth = firstSet.offsetWidth;
        }

        // Set CSS animation via custom properties
        var duration = setWidth / PIXELS_PER_SECOND;
        track.style.setProperty('--carousel-duration', duration + 's');
    }

    // Run on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initLogoCarousels);
    } else {
        initLogoCarousels();
    }

    // Recalculate on window resize
    var resizeTimer;
    window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            // Re-init requires fresh DOM; reload sets from scratch
            initLogoCarousels();
        }, 200);
    });
})();
